'use es6';

import { DragSource, DropTarget } from 'react-dnd';
import { pick } from 'underscore';
import { TAB } from 'DesignData/enums/DragDropItemTypes';
export const tabDragSource = DragSource(TAB, {
  beginDrag(props) {
    return pick(props, ['tabId']);
  },

  endDrag(props) {
    if (!props.activeId !== props.tabId) {
      props.makeTabActive();
    }
  }

}, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
}));
export const tabDropTarget = DropTarget(TAB, {
  drop(props, monitor) {
    const {
      tabId: itemId
    } = monitor.getItem();
    const {
      tabId,
      tabsOrder,
      moveTab
    } = props;

    if (itemId !== tabId) {
      const newIndex = tabsOrder.indexOf(tabId);
      moveTab(itemId, newIndex);
    }
  }

}, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}));